import React from "react";
import { Autocomplete, TextField } from "@mui/material";

interface User {
  firstName: string;
  lastName: string;
}

interface UserAutocompleteProps {
  users: User[];
  selectedUser: User | null;
  onSelect: (user: User | null) => void;
}

const UserAutocomplete: React.FC<UserAutocompleteProps> = ({ users = [], selectedUser, onSelect }) => {
  return (
    <div className="w-full">
    <Autocomplete
      options={users}
      getOptionLabel={(user) => `${user.firstName} ${user.lastName}`}
      value={selectedUser}
      onChange={(e, val) => onSelect(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search Member"
          variant="outlined"
          size="small" // 🔥 this is the fix
        />
      )}
    />

    </div>
  );
};

export default UserAutocomplete;
